import { Button, Tooltip } from 'antd';
import React, { useRef } from 'react';
import ReactToPrint from 'react-to-print';
import FormDeviceMaintance from './FormDeviceMaintance';
class ComponentToPrint extends React.Component {
  render() {
    return (
      <div className="report">
        <FormDeviceMaintance deviceLst={this.props.deviceLst} devices={this.props.devices}></FormDeviceMaintance>
      </div>
    );
  }
}

const PrintDeviceOffer = ({ deviceLst = [] }) => {
  const devices = [];
  const valueQrCode = useRef();
  deviceLst.forEach((device) => {
    if (device.DeviceOfferLineLst.length > 0) {
      devices.push(device.DeviceOfferLineLst);
    }
  });
  return (
    <div style={{ marginRight: 5 }}>
      <div style={{ display: 'none' }}>
        <ComponentToPrint ref={valueQrCode} deviceLst={deviceLst} devices={devices.flat()} />
      </div>
      <ReactToPrint
        documentTitle="Thông tin thiết bị"
        trigger={() => (
          <div type="primary">
            <Tooltip title="In phiếu danh sách thiết bị luân chuyển" placement="bottom">
              <Button>In báo cáo</Button>
            </Tooltip>
          </div>
        )}
        content={() => valueQrCode.current}
      />
    </div>
  );
};
export default PrintDeviceOffer;
